import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  // Data from Resources
  public resourceFilterEvent(eventName: string, filterCategory: string, filterLabel: string, filterAction: string = null, filterValue: string = null) {
    gtag('event', eventName, { 
      resourceFilterCategory: filterCategory, 
      resourceFilterLabel: filterLabel, 
      resourceFilterAction: filterAction, 
      resourceFilterValue: filterValue
    })
  }

  // Data from select-area
  public areafilterEvent(eventName: string, filterCategory: string, filterAction: string = null, areaCode: string, areaId: number, areaName: string = null, areaSystemLevelName: string = null) { 
    gtag('event', eventName, {
      areaFilterCategory: filterCategory,
      areaFilterAction: filterAction,  
      areaCode: areaCode, 
      areaId: areaId, 
      areaName: areaName, 
      areaSystemLevelName: areaSystemLevelName
    })
  }

    // Data from select-indicator-name
    public indicatorfilterEvent(eventName: string, filterCategory: string, filterAction: string = null, filterValue: string = null) { 
      gtag('event', eventName, {
        indicatorFilterCategory: filterCategory,
        indicatorFilterAction: filterAction,   
        indicatorFilterValue: filterValue
      })
    }

    // Data from select-indicator-short-name
    public indicatorShortNamefilterEvent(eventName: string, filterCategory: string, filterAction: string = null, filterValue: string = null) { 
      gtag('event', eventName, {
        indicatorShortNameCategory: filterCategory,
        indicatorShortNameAction: filterAction,   
        indicatorShortNameValue: filterValue
      })
    }

    // Data from select-indicator-code
    public indicatorCodefilterEvent(eventName: string, filterCategory: string, filterAction: string = null, filterValue: string = null) { 
      gtag('event', eventName, {
        indicatorCodeCategory: filterCategory,
        indicatorCodeAction: filterAction,   
        indicatorCodeValue: filterValue
      })
    }

  // Data from Data Extract
  public dataExtractFilterEvent(eventName: string, filterCategory: string, filterLabel: string, filterAction: string = null, filterValue: string = null) {
    gtag('event', eventName, { 
      dataExtractFilterCategory: filterCategory, 
      dataExtractFilterLabel: filterLabel, 
      dataExtractFilterAction: filterAction, 
      dataExtractFilterValue: filterValue
    })
  }

    // Data from Metadata
    public metadata(eventName: string, action: string = null, value: string = null) {
      gtag('event', eventName, { 
        metadatAction: action,
        metadataValue: value
      })
    }

    public downloadMetadata(eventName: string, action: string = null, value: string = null) {
      gtag('event', eventName, { 
        downloadedMetadataAction: action,
        downloadedMetadataValue: value
      })
    }

    // Data from Footer
    public privacyPolicyEvent(eventName: string, action: string = null) {
      gtag('event', eventName, { 
        privacyPolicyEventAction: action,
      })
    }

    public feedbackEvent(eventName: string, action: string = null) {
      gtag('event', eventName, { 
        feedbackEventAction: action,
      })
    }

    // Data from Home
    public watchIntroductoryVideo(eventName: string, action: string = null) {
      gtag('event', eventName, { 
        watchIntroductoryVideoAction: action, 
      })
    }

    // Data from Quality Improvement
    public qIInequalitiesFilterEvent(eventName: string, filterCategory: string, filterLabel: string, filterAction: string = null, filterValue: string = null) {
      gtag('event', eventName, { 
        qIInequalitiesFilterEventCategory: filterCategory, 
        qIInequalitiesFilterEventLabel: filterLabel, 
        qIInequalitiesFilterEventAction: filterAction, 
        qIInequalitiesFilterEventValue: filterValue
      })
    }
}
